module.exports = {
    "url": "https://www4.unimednoroesters.com.br/clinic/",
	// "url": "https://www4.unimednoroesters.com.br/clinic_teste/",
    "versao": "2.0.0",
    "telefone": "tel:5533319600",
    "whatsapp": "https://api.whatsapp.com/send?phone=555533319600&text=Olá",
    "instagram": "https://instagram.com/unimednors",
    "facebook": "https://www.facebook.com/unimednors",
    "site": "http://unimednoroesters.com.br/",
    "loginTexto": "Clinic - Portal de Exames Unimed",
    "googleAnalytics": {
        "id": ""
    },
    "pusher": {
        "key": "b60c3a5104cd0d0c43fc"
    },
    "sintomas": {
        "itens": []
    },
    "money": {
        "decimal": ',',
        "thousands": '.',
        "prefix": '',
        "suffix": '',
        "precision": 2,
        "masked": false
    }	
}


//////////////////
// WEBPACK FOOTER
// ./static/config/app.js
// module id = KY5p
// module chunks = 1